import { createRouter, createWebHistory } from "vue-router";
import Home from "../components/home/Home.vue";
import Service from "../components/service/Service.vue";
import About from "../components/About.vue";
import Booking from "../components/booking/Booking.vue";
import selectDate from "../components/selectDate/date.vue";
import Payment from "../components/payment/payment.vue";
import Contact from "../components/contact/contact.vue";
import dogGrooming from "../components/dogGrooming/dogGrooming.vue";
import catGrooming from "../components/catGrooming/catGrooming.vue";
import birdsGrooming from "../components/birdsGrooming/birdsGrooming.vue";
import rabbitGrooming from "../components/rabbitGrooming/rabbitGrooming.vue";
import aboutUs from "../components/aboutUs/about.vue";
import backHome from "../components/backHome/backHome.vue";
import thankYou from "../components/thankYou/thankYou.vue";
import privacy from "../components/privacy/privacy.vue";
import termsCondition from "../components/termsCondition/termsCondition.vue";
import refundPolicy from "../components/refundPolicy/refundPolicy.vue";
import blog from "../components/blog/blog.vue";
import blogDetail from "../components/blogDetail/blogDetail.vue";
import NotFound from "../components/NotFound.vue";

// const routes = [
//   { path: "/", component: Home },
//   { path: "/service", component: Service },
//   { path: "/about", component: About },
//   { path: "/booking", component: Booking },
//   { path: "/date", component: selectDate },
//   { path: "/payment", component: Payment },
//   { path: "/contact", component: Contact },
//   { path: "/dogGrooming", component: dogGrooming },
//   { path: "/catGrooming", component: catGrooming },
//   { path: "/aboutUs", component: aboutUs },
//   { path: "/backHome", component: backHome },
//    { path: "/birdsGrooming", component: birdsGrooming },
//   { path: "/rabbitGrooming", component: rabbitGrooming },
// ];

// const router = createRouter({
//   history: createWebHistory(), // Make sure you're using history mode
//   routes,
// });

// export default router;

const routes = [
  {
    path: "/",
    component: Home,
    meta: {
      title: "Get The Best Mobile Pet Grooming Service In Dubai",
      description: "Are you a pet lover and looking for the best pet groomer in Dubai for your buddy? We are here to offer a wide range of mobile pet grooming services designed to meet your pet's needs.",
    },
  },
  {
    path: "/services/",
    component: Service,
    meta: {
      title: "Book Mobile pet grooming services in dubai",
      description: "Are you a pet owner and searching for best grooming services in Dubai? Visit Dubai Pet Groomer for affordable and premium grooming services, offering royal care for pets of all kinds.",
    },
  },
  {
    path: "/about",
    component: About,
    meta: {
      title: "About Us - Dubai Pets Groomer",
      description: "Dubai Pet Groomer offers premium mobile pet grooming services across Dubai. We provide professional, convenient, and affordable grooming for pets of all sizes, right at your door!",
    },
  },
  {
    path: "/blog/",
    component: blog,
    meta: {
      title: "Get Latest Info About Pet Grooming - Dubai Pets Groomer",
      description: "Dubai Pet Groomer is the place where you can learn all about pet grooming and how to keep your pet healthy and safe.",
    },
  },
  {
    path: '/blog/:slug',
    component: blogDetail,
    meta: {
      title: "Get Latest Info About Pet Grooming - Dubai Pets Groomer",
      description: "Dubai Pet Groomer is the place where you can learn all about pet grooming and how to keep your pet healthy and safe.",
    },
  },
  {
    path: "/booking/",
    component: Booking,
    meta: {
      title: "Book Professional Mobile Pet Groomer at Reasonable price",
      description: "Book a professional mobile pet groomer in Dubai at a reasonable price! Enjoy high-quality grooming services for your pet, delivered right to your doorstep.",
    },
  },
  {
    path: "/date",
    component: selectDate,
    meta: {
      noindex: true
    },
  },
  {
    path: "/payment",
    component: Payment,
    meta: {
      title: "Return and Refund Policy - Dubai Pets Groomer",
      description: "Thank you for choosing Dubai Pets Groomer. We strive to provide the highest quality grooming services to all of our clients and their beloved pets. ",
    },
  },
  {
    path: "/contact-us",
    component: Contact,
    meta: {
      title: "Contact Us - Dubai Pets Groomer",
      description: "Get in touch with Dubai Pet Groomer for best mobile pet grooming services in Dubai. Book an appointment today and have your pet groomed at your doorstep!",
    },
  },
  {
    path: "/services/mobile-dog-grooming-dubai-pet-groomer/",
    component: dogGrooming,
    meta: {
      title: "Mobile Dog Grooming Services in Dubai – Treat Your Pet with Care",
      description: "Searching for the experienced pet groomer in Dubai? We as a Mobile Dog Grooming Service provider, offer quality services with experienced staff that treat your pet with extra care",
    },
  },
  {
    path: "/services/mobile-cat-grooming-service-dubai/",
    component: catGrooming,
    meta: {
      title: "Professional Mobile Cat Grooming Home Service In Dubai",
      description: "Are you in need of a budget-friendly mobile cat grooming service in Dubai? We are here to help you! At Dubai Pet Groomers, we believe that every feline deserves individualized care and attention.",
    },
  },
  {
    path: "/about-us",
    component: aboutUs,
    meta: {
      title: "About Us - Dubai Pets Groomer",
      description: "Dubai Pet Groomer offers premium mobile pet grooming services across Dubai. We provide professional, convenient, and affordable grooming for pets of all sizes, right at your door!",
    },
  },
  {
    path: "/backHome",
    component: backHome,
    meta: {
      title: "Get The Best Mobile Pet Grooming Service In Dubai",
      description: "Are you a pet lover and looking for the best pet groomer in Dubai for your buddy? We are here to offer a wide range of mobile pet grooming services designed to meet your pet's needs.",
    },
  },
  {
    path: "/booking/thank-you",
    name: "thankYou",
    component: thankYou,
    props: route => ({
      customerName: route.query.customerName
    }),
    meta: {
      title: "Get The Best Mobile Pet Grooming Service In Dubai",
      description: "Are you a pet lover and looking for the best pet groomer in Dubai for your buddy? We are here to offer a wide range of mobile pet grooming services designed to meet your pet's needs.",
    },
  },
  {
    path: "/services/bird-grooming-services-dubai-pet-groomer/",
    component: birdsGrooming,
    meta: {
      title: "Bird Grooming Services | Best Bird Care Company In Dubai",
      description: "Are your feathered companions and searching for the best bird care company in dubai that offers bird grooming services at affordable prices? Look no further! At Dubai Pet Groomers,",
    },
  },
  {
    path: "/services/rabbit-grooming-dubai-mobile-pet-groomer/",
    component: rabbitGrooming,
    meta: {
      title: "Professional Rabbit Grooming Service in Dubai",
      description: "Are you a pet lover searching for affordable rabbit grooming services in Dubai? Welcome to Dubai Pet Groomer, where pets of all sizes and shapes are provided the utmost royal treatment.",
    },
  },
  {
    path: "/privacy",
    component: privacy,
    meta: {
      title: "Privacy Policy - Dubai Pets Groomer",
      description: "At Dubai Pet Groomers, we are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, disclose, and safeguard your information",
    },
  },
  {
    path: "/termsCondition",
    component: termsCondition,
    meta: {
      title: "terms condition text",
      description: "terms condition content",
    },
  },
  {
    path: "/refundPolicy",
    component: refundPolicy,
    meta: {
      title: "Return and Refund Policy - Dubai Pets Groomer",
      description: "Thank you for choosing Dubai Pets Groomer. We strive to provide the highest quality grooming services to all of our clients and their beloved pets.",
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
    meta: {
      title: "Page Not Found - Dubai Pets Groomer",
      description: "The page you're looking for does not exist. Explore our mobile pet grooming services in Dubai or book online.",
      noindex: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0 }
  }
});

export default router;

